export const NO_CACHE = 0;
export const CACHE_30S = 30_000;
export const CACHE_1M = 60_000;
export const CACHE_5M = 300_000;
export const CACHE_15M = 900_000;
export const CACHE_30M = 1_800_000;
export const CACHE_1H = 3_600_000;
export const CACHE_2H = 7_200_000;
export const CACHE_6H = 21_600_000;
export const CACHE_12H = 43_200_000;
export const CACHE_24H = 86_400_000;
export const CACHE_7D = 604_800_000;
